import React, { useEffect, useState, useContext } from "react";
import "./CustodyLog.css";
import Navbar from "./Navbar";
import { LanguageContext } from "./LanguageContext";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { HiOutlinePrinter } from "react-icons/hi";
import enTranslations from "./translations/en.json";
import guTranslations from "./translations/gu.json";
import hinTranslations from "./translations/hi.json";
import mrTranslations from "./translations/mr.json";

import API_URL from "./Config";

function CustodyLog() {
  const [statusDetails, setStatusDetails] = useState({});
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const { id } = useParams();

  const { selectedLanguage } = useContext(LanguageContext);

  const translations = {
    en: enTranslations,
    gu: guTranslations,
    hi: hinTranslations,
    mr: mrTranslations,
  };
  // function formatDates(inputDate) {
  //   const options = {
  //     month: "2-digit",
  //     day: "2-digit",
  //     year: "numeric",
  //     // hour: "2-digit",
  //     // minute: "2-digit",
  //     hour12: false,
  //     timeZone: "UTC",
  //   };

  //   const date = new Date(inputDate);
  //   const formattedDate = date.toLocaleDateString("en-US", options);
  //   return formattedDate;
  // }

  // const formatDates = (inputDate) => {
  //   const date = new Date(inputDate);
  //   const formatter = new Intl.DateTimeFormat("en-GB", {
  //     day: "2-digit",
  //     month: "2-digit",
  //     year: "numeric",
  //   });
  //   return formatter.format(date);
  // };
  // function formatDates(inputDate) {
  //   const options = {
  //     day: "2-digit",
  //     month: "2-digit",
  //     year: "numeric",
  //   };

  //   const date = new Date(inputDate);

  //   const day = String(date.getDate()).padStart(2, '0');
  //   const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  //   const year = date.getFullYear();

  //   const formattedDate = `${day}/${month}/${year}`;
  //   return formattedDate;
  // }

  function formatDates(inputDate) {
    // Check if inputDate is null or undefined
    if (inputDate === null || inputDate === undefined) {
      return "NA";
    }

    // Attempt to create a new Date object
    const date = new Date(inputDate);

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return "NA";
    }

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();

    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate;
  }

  // Example usage
  console.log(formatDates("2023-07-29")); // 29/07/2023
  console.log(formatDates(null)); // NA
  console.log(formatDates("invalid-date")); // NA

  function formatDate(inputDate) {
    if (inputDate === null || inputDate === undefined) {
      return "NA";
    }

    const date = new Date(inputDate);

    if (isNaN(date.getTime())) {
      return "NA";
    }

    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getUTCFullYear();

    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");

    const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}`;
    return formattedDate;
  }

  const translatedText = (key) => translations[selectedLanguage][key] || key;
  const hasMeaningfulValue = (value) => {
    const normalizedValue = String(value ?? "").trim();
    return normalizedValue !== "" && normalizedValue.toUpperCase() !== "NA";
  };
  const matchesTranslatedStatus = (statusValue, translationKey) =>
    hasMeaningfulValue(statusValue) &&
    translatedText(translationKey).includes(statusValue);
  const matchesAnyStatus = (statusValue, values) =>
    hasMeaningfulValue(statusValue) && values.includes(statusValue);

  useEffect(() => {
    const authKey = localStorage.getItem("authKey");
    const apiUrl = `${API_URL}/api/get_custody_log_status/${id}`;

    const fetchData = async () => {
      try {
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: authKey,
            "Cache-Control": "no-cache",
          },
        });

        if (!response.ok) {
          throw new Error(`Error fetching data: ${response.statusText}`);
        }

        const data = await response.json();
        setStatusDetails(data);
      } catch (error) {
        console.error("Error fetching status details by ID:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();

    // Add click event listener for print inside useEffect
    document.addEventListener("click", handlePrint, false);

    // Cleanup: Remove the event listener when the component unmounts
    return () => {
      document.removeEventListener("click", handlePrint, false);
    };
  }, [id]);

  const handlePrint = (event) => {
    if (!event.target.matches("#print-page")) return;
    event.preventDefault();
    if (window.console) console.log(statusDetails);
    window.print();
  };

  return (
    <>
      <Navbar />
      <div className="chain-popup-container">
        <div className="popup-chain-blog-content">
          <div className="chain-blog-data">
            <nav className="jump-to">
              <button
                onClick={() => navigate("/datalist")}
                className="print-icon button-print"
              >
                <IoMdArrowRoundBack className="custody-print-buttons" />
                Back
              </button>
            </nav>
            <div className="timelines">
              <div className="side-content">
                <section className="timeline education left-side custody-timeline-panel">
                  <div className="print-only">
                    <h2 id="experience">
                      {translatedText("status_of_muddamaal")}
                    </h2>
                  </div>
                  <ul className="timeline-items">
                    {statusDetails.length > 0 ? (
                      statusDetails.map((status, index) => (
                        <li className="timeline-item" key={index}>
                          <span className="date-intervals">
                            <p className="title">Updated On</p>
                            <p className="date">{formatDate(status.ist_time)}</p>
                          </span>
                          <div className="timeline-item__content">
                            <h4>{status.status_of_muddamaal || "NA"}</h4>
                            {status.status_of_muddamaal ===
                              translatedText("destroyed_disposed") ? (
                              <div>
                                {status.disposalOnCourt === "Disposed" && (
                                  <div>
                                    <p className="location">
                                      {translatedText("disposal_on_court_order")}:{" "}
                                      {status.disposalOnCourt || "NA"}
                                    </p>
                                    <p className="location">
                                      {translatedText("order_no_for_deputed")}:{" "}
                                      {status.executiveOrder || "NA"}
                                    </p>
                                    <p className="location">
                                      {translatedText("date_of_disposal")}:{" "}
                                      {formatDates(status.disposalDate)}
                                    </p>
                                  </div>
                                )}
                                {status.disposalOnCourt === "Auction" && (
                                  <div>
                                    <p className="location">
                                      {translatedText("disposal_on_court_order")}:{" "}
                                      {status.disposalOnCourt || "NA"}
                                    </p>
                                    <p className="location">
                                      {translatedText("date_of_auction")}:{" "}
                                      {formatDates(status.auctionDate)}
                                    </p>
                                    <p className="location">
                                      {translatedText("auction_order_no")}:{" "}
                                      {status.auctionOrderNo || "NA"}
                                    </p>
                                    <p className="location">
                                      {translatedText("awarded_to_whom")}:{" "}
                                      {status.awarded || "NA"}
                                    </p>
                                    <p className="location">
                                      {translatedText("payment_made_through")}:{" "}
                                      {status.paymentMode || "NA"}
                                    </p>
                                    <p className="location">
                                      {translatedText("handover_memo_no")}:{" "}
                                      {status.auctionMemoNo || "NA"}
                                    </p>
                                  </div>
                                )}
                              </div>
                            ) : null}

                            {status.status_of_muddamaal ===
                              translatedText("sent_to_ps_ccs") ? (
                              <div>
                                <p className="location">
                                  {translatedText("sent_by")}:{" "}
                                  {status.sent_by || "NA"}
                                </p>
                                <p className="location">
                                  {translatedText("Date")}:{" "}
                                  {formatDates(status.date)}
                                </p>
                              </div>
                            ) : null}

                            {status.status_of_muddamaal ===
                              translatedText("central_cold_storage") ? (
                              <div>
                                <p className="location">
                                  {translatedText("sent_by")}:{" "}
                                  {status.sent_by || "NA"}
                                </p>
                                <p className="location">
                                  {translatedText("Date")}:{" "}
                                  {formatDates(status.date)}
                                </p>
                              </div>
                            ) : null}

                            {status.status_of_muddamaal ===
                              translatedText("release_on_court_order") ? (
                              <div>
                                <p className="location">
                                  {translatedText("court_order_no")}:{" "}
                                  {status.courtOrderNo || "NA"}
                                </p>
                                <p className="location">
                                  {translatedText("released_to_whom")}:{" "}
                                  {status.releasedToWhom || "NA"}
                                </p>
                                <p className="location">
                                  {translatedText("date_of_release")}:{" "}
                                  {formatDates(status.releseddate)}
                                </p>
                                <p className="location">
                                  {translatedText("gd_entry_no")}:{" "}
                                  {status.gdNo || "NA"}
                                </p>
                              </div>
                            ) : null}

                            {status.status_of_muddamaal ===
                              translatedText("handed_over_to_other_department") ? (
                              <div>
                                <p className="location">
                                  {translatedText("handover_memo_no")}:{" "}
                                  {status.handoverMemoNo || "NA"}
                                </p>
                                <p className="location">
                                  {translatedText("date_of_handing_over")}:{" "}
                                  {formatDates(status.dateOfHandingOver)}
                                </p>
                              </div>
                            ) : null}

                            {status.status_of_muddamaal ===
                              translatedText("other") ? (
                              <div>
                                <p className="location">
                                  {translatedText("other_status_case_property")}:{" "}
                                  {status.other_status_case_property || "NA"}
                                </p>
                              </div>
                            ) : null}

                            {[
                              translatedText("police_station_account"),
                              translatedText("comes_from_court"),
                              translatedText("comes_from_bank"),
                            ].includes(status.status_of_muddamaal) ? (
                              <div>
                                <p className="location">
                                  {translatedText("name")}: {status.name || "NA"}
                                </p>
                                <p className="location">
                                  {translatedText("date")}:{" "}
                                  {formatDates(status.date)}
                                </p>
                                <p className="location">
                                  {translatedText("order_no")}:{" "}
                                  {status.order_no || "NA"}
                                </p>
                              </div>
                            ) : null}

                            {status.status_of_muddamaal ===
                              translatedText("released_in_fsl") ? (
                              <div>
                                <p className="location">
                                  {translatedText("name")}: {status.name || "NA"}
                                </p>
                                <p className="location">
                                  {translatedText("date")}:{" "}
                                  {formatDates(status.date)}
                                </p>
                                <p className="location">
                                  {translatedText("order_no")}:{" "}
                                  {status.javak_no || "NA"}
                                </p>
                                <p className="location">
                                  FSL List: {status.fslList || "NA"}
                                </p>
                                <p className="location">
                                  {translatedText("name_of_cfsl")}:{" "}
                                  {status.cfslName || "NA"}
                                </p>
                              </div>
                            ) : null}

                            {status.status_of_muddamaal ===
                              translatedText("comes_from_fsl") ? (
                              <div>
                                <p className="location">
                                  {translatedText("name")}: {status.name || "NA"}
                                </p>
                                <p className="location">
                                  {translatedText("date")}:{" "}
                                  {formatDates(status.date)}
                                </p>
                                <p className="location">
                                  {translatedText("order_no")}:{" "}
                                  {status.order_no || "NA"}
                                </p>
                                <p className="location">
                                  FSL List: {status.fslList || "NA"}
                                </p>
                                <p className="location">
                                  {translatedText("name_of_cfsl")}:{" "}
                                  {status.cfslName || "NA"}
                                </p>
                              </div>
                            ) : null}

                            {[
                              translatedText("returned"),
                              translatedText("pending_in_court"),
                              translatedText("deposited_in_bank"),
                            ].includes(status.status_of_muddamaal) ? (
                              <div>
                                <p className="location">
                                  {translatedText("name")}: {status.name || "NA"}
                                </p>
                                <p className="location">
                                  {translatedText("date")}:{" "}
                                  {formatDates(status.date)}
                                </p>
                                <p className="location">
                                  {translatedText("order_no")}:{" "}
                                  {status.javak_no || "NA"}
                                </p>
                              </div>
                            ) : null}
                          </div>
                        </li>
                      ))
                    ) : (
                      <li className="timeline-item">
                        <span className="date-intervals">
                          <p className="title">Updated On</p>
                          <p className="date">
                            {formatDate(
                              statusDetails?.status_details?.ist_time || "NA"
                            )}
                          </p>
                        </span>
                        <div className="timeline-item__content">
                          <h3>
                            {statusDetails?.status_details?.status_of_muddamaal ||
                              "NA"}
                          </h3>

                          {statusDetails?.status_details?.status_of_muddamaal ===
                            "Disposed" && (
                              <div>
                                <p className="location">
                                  {translatedText("disposal_on_court_order")}:{" "}
                                  {statusDetails?.status_details?.disposalOnCourt ||
                                    "NA"}
                                </p>
                                <p className="location">
                                  {translatedText("order_no_for_deputed")}:{" "}
                                  {statusDetails?.status_details?.executiveOrder ||
                                    "NA"}
                                </p>
                                <p className="location">
                                  {translatedText("date_of_disposal")}:{" "}
                                  {formatDates(
                                    statusDetails?.status_details?.disposalDate ||
                                      "NA"
                                  )}
                                </p>
                              </div>
                            )}

                          {statusDetails?.status_details?.status_of_muddamaal ===
                            "Auction" && (
                              <div>
                                <p className="location">
                                  {translatedText("disposal_on_court_order")}:{" "}
                                  {statusDetails?.status_details?.disposalOnCourt ||
                                    "NA"}
                                </p>
                                <p className="location">
                                  {translatedText("date_of_auction")}:{" "}
                                  {formatDates(
                                    statusDetails?.status_details?.auctionDate ||
                                      "NA"
                                  )}
                                </p>
                                <p className="location">
                                  {translatedText("auction_order_no")}:{" "}
                                  {statusDetails?.status_details?.auctionOrderNo ||
                                    "NA"}
                                </p>
                                <p className="location">
                                  {translatedText("awarded_to_whom")}:{" "}
                                  {statusDetails?.status_details?.awarded || "NA"}
                                </p>
                                <p className="location">
                                  {translatedText("payment_made_through")}:{" "}
                                  {statusDetails?.status_details?.paymentMode ||
                                    "NA"}
                                </p>
                                <p className="location">
                                  {translatedText("handover_memo_no")}:{" "}
                                  {statusDetails?.status_details?.auctionMemoNo ||
                                    "NA"}
                                </p>
                              </div>
                            )}

                          {matchesTranslatedStatus(
                            statusDetails?.status_details?.status_of_muddamaal,
                            "handed_over_to_other_department"
                          ) && (
                              <div>
                                <p className="location">
                                  {translatedText("handover_memo_no")}:{" "}
                                  {statusDetails?.status_details?.handoverMemoNo ||
                                    "NA"}
                                </p>
                                <p className="location">
                                  {translatedText("date_of_handing_over")}:{" "}
                                  {formatDates(
                                    statusDetails?.status_details
                                      ?.dateOfHandingOver || "NA"
                                  )}
                                </p>
                              </div>
                            )}

                          {matchesTranslatedStatus(
                            statusDetails?.status_details?.status_of_muddamaal,
                            "release_on_court_order"
                          ) && (
                              <div>
                                <p className="location">
                                  {translatedText("court_order_no")}:{" "}
                                  {statusDetails?.status_details?.courtOrderNo ||
                                    "NA"}
                                </p>
                                <p className="location">
                                  {translatedText("released_to_whom")}:{" "}
                                  {statusDetails?.status_details?.releasedToWhom ||
                                    "NA"}
                                </p>
                                <p className="location">
                                  {translatedText("date_of_release")}:{" "}
                                  {formatDates(
                                    statusDetails?.status_details?.releseddate ||
                                      "NA"
                                  )}
                                </p>
                                <p className="location">
                                  {translatedText("gd_entry_no")}:{" "}
                                  {statusDetails?.status_details?.gdNo || "NA"}
                                </p>
                              </div>
                            )}

                          {matchesAnyStatus(
                            statusDetails?.status_details?.status_of_muddamaal,
                            [
                              translatedText("police_station_account"),
                              translatedText("comes_from_court"),
                              translatedText("comes_from_bank"),
                            ]
                          ) && (
                              <div>
                                <p className="location">
                                  {translatedText("name")}:{" "}
                                  {statusDetails?.status_details?.name || "NA"}
                                </p>
                                <p className="location">
                                  {translatedText("date")}:{" "}
                                  {formatDates(
                                    statusDetails?.status_details?.date || "NA"
                                  )}
                                </p>
                                <p className="location">
                                  {translatedText("order_no")}:{" "}
                                  {statusDetails?.status_details?.order_no || "NA"}
                                </p>
                              </div>
                            )}

                          {matchesTranslatedStatus(
                            statusDetails?.status_details?.status_of_muddamaal,
                            "released_in_fsl"
                          ) && (
                              <div>
                                <p className="location">
                                  {translatedText("name")}:{" "}
                                  {statusDetails?.status_details?.name || "NA"}
                                </p>
                                <p className="location">
                                  {translatedText("date")}:{" "}
                                  {formatDates(
                                    statusDetails?.status_details?.date || "NA"
                                  )}
                                </p>
                                <p className="location">
                                  {translatedText("order_no")}:{" "}
                                  {statusDetails?.status_details?.javak_no || "NA"}
                                </p>
                                <p className="location">
                                  {translatedText("name_of_cfsl")}:{" "}
                                  {statusDetails?.status_details?.cfslName || "NA"}
                                </p>
                              </div>
                            )}
                          {matchesTranslatedStatus(
                            statusDetails?.status_details?.status_of_muddamaal,
                            "comes_from_fsl"
                          ) && (
                              <div>
                                <p className="location">
                                  {translatedText("name")}:{" "}
                                  {statusDetails?.status_details?.name || "NA"}
                                </p>
                                <p className="location">
                                  {translatedText("date")}:{" "}
                                  {formatDates(
                                    statusDetails?.status_details?.date || "NA"
                                  )}
                                </p>
                                <p className="location">
                                  {translatedText("order_no")}:{" "}
                                  {statusDetails?.status_details?.order_no || "NA"}
                                </p>
                                <p className="location">
                                  {translatedText("name_of_cfsl")}:{" "}
                                  {statusDetails?.status_details?.cfslName || "NA"}
                                </p>
                              </div>
                            )}

                          {matchesAnyStatus(
                            statusDetails?.status_details?.status_of_muddamaal,
                            [
                              translatedText("returned"),
                              translatedText("pending_in_court"),
                              translatedText("deposited_in_bank"),
                            ]
                          ) && (
                              <div>
                                <p className="location">
                                  {translatedText("name")}:{" "}
                                  {statusDetails?.status_details?.name || "NA"}
                                </p>
                                <p className="location">
                                  {translatedText("date")}:{" "}
                                  {formatDates(
                                    statusDetails?.status_details?.date || "NA"
                                  )}
                                </p>
                                <p className="location">
                                  {translatedText("order_no")}:{" "}
                                  {statusDetails?.status_details?.javak_no || "NA"}
                                </p>
                              </div>
                            )}
                        </div>
                      </li>
                    )}
                  </ul>
                </section>
              </div>

              <div className="right-content">
                <div className="right-side-container">
                  <div className="timeline-title">
                    <h2 id="experience">
                      {translatedText("status_of_muddamaal")}
                    </h2>
                  </div>
                  <button
                    id="print-page"
                    className="print-icon button-print"
                    onClick={handlePrint}
                  >
                    <HiOutlinePrinter className="custody-print-button" /> Print
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CustodyLog;
